var __awaiter =
  (this && this.__awaiter) ||
  function (k, l, m, o) {
    function p(q) {
      if (q instanceof m) {
        return q;
      } else {
        return new m(function (u) {
          u(q);
        });
      }
    }
    return new (m ||= Promise)(function (q, u) {
      function v(y) {
        try {
          x(o.next(y));
        } catch (z) {
          u(z);
        }
      }
      function w(y) {
        try {
          x(o.throw(y));
        } catch (z) {
          u(z);
        }
      }
      function x(y) {
        if (y.done) {
          q(y.value);
        } else {
          p(y.value).then(v, w);
        }
      }
      x((o = o.apply(k, l || [])).next());
    });
  };
Object.defineProperty(exports, "__esModule", {
  value: true,
});
const urlParse = require("url-parse");
class QueueManager {
  constructor(k, l, m, p, q, u, v, w) {
    this.manager = k;
    this.queueClientId = l;
    this.queueClientKey = m;
    this.statusCallback = p;
    this.hostCallback = q;
    this.joinCallback = u;
    this.cancelJoinCallback = v;
    this.kickCallback = w;
    this.status = "Queuing";
    this.queueSize = 0;
    this.newGameId = null;
  }
  get isQueued() {
    return (
      this.status != "Queuing" &&
      this.status != "CreatingGame" &&
      this.status != "Join"
    );
  }
  get isActive() {
    return this.manager.queueManager === this;
  }
  forcePoll() {
    return __awaiter(this, undefined, undefined, function* () {
      yield this._poll();
    });
  }
  _start() {
    return __awaiter(this, undefined, undefined, function* () {
      this._poll();
    });
  }
  _resetPollTimer() {
    if (this.pollTimeoutId) {
      clearTimeout(this.pollTimeoutId);
    }
    this.pollTimeoutId = window.setTimeout(() => {
      if (this.isActive) {
        this._poll();
      }
    }, 1000);
  }
  _poll() {
    return __awaiter(this, undefined, undefined, function* () {
      this._resetPollTimer();
      try {
        let k = yield this.manager.matchmakerRequest("/queue/poll", {
          clientKey: this.queueClientKey,
        });
        this._handleNewPollResponse(k);
      } catch (l) {
        if (
          l.response &&
          l.response.data &&
          (l.response.data.error == "InvalidClientId" ||
            l.response.data.error == "InvalidClientKey")
        ) {
          if (this.isActive) {
            this.manager.unqueue();
          }
          this.kickCallback();
        }
      }
    });
  }
  _handleNewPollResponse(k) {
    if (!this.isActive) {
      return;
    }
    let l = k.status;
    let m = this.status;
    this.status = l.t;
    switch (l.t) {
      case "Queued":
        this.queueSize = l.c.queueSize;
        break;
      case "CreatingGame":
        break;
      case "HostGame":
        this.hostCallback(l.c.host, l.c.port, l.c.pendingGameId);
        break;
      case "Join":
        let o = l.c.gameId;
        if (o != this.newGameId) {
          this.newGameId = o;
          this.joinCallback(o);
        }
        break;
      default:
        console.error("Unknown status", l);
        return;
    }
    if (
      (m == "CreatingGame" || m == "HostGame" || m == "Join") &&
      l.t != "CreatingGame" &&
      l.t != "HostGame" &&
      l.t != "Join"
    ) {
      this.newGameId = null;
      this.cancelJoinCallback();
    }
    this.statusCallback(k);
  }
}
exports.QueueManager = QueueManager;
class ClientManager {
  constructor(k, l) {
    this.matchmakerAddress = k;
    this.availableRegions = l;
    this.cachePingRegion = true;
    this.enableLogging = !!localStorage.getItem("CLIENT_MANAGER_LOGGING");
  }
  get hostname() {
    return localStorage.__HOSTNAME__ || location.hostname;
  }
  get inQueue() {
    return this.queueManager != null;
  }
  seek(seekData) {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Seeking games...");
      let regionId =
        localStorage.__REGION__ ||
        seekData.regionId ||
        (yield this.getRegion());
      let gameId = seekData.gameId || this.parseQuery();
      let matchmakerRes = yield this.matchmakerSeek(
        regionId,
        gameId,
        seekData.dataQuery || null,
        seekData.autoChangeGame,
        seekData.validationToken,
        seekData.captchaToken,
      );
      if (!seekData.skipReplaceState) {
        window.history.replaceState(
          document.title,
          document.title,
          this.generateHref(matchmakerRes.gameId),
        );
      }
      return matchmakerRes;
    });
  }
  getRegion() {
    return __awaiter(this, undefined, undefined, function* () {
      return new Promise((resolve, reject) =>
        __awaiter(this, undefined, undefined, function* () {
          let pingRegionCache = localStorage.getItem(
            ClientManager.PING_REGION_CACHE_KEY,
          );
          if (
            pingRegionCache &&
            this.availableRegions.indexOf(pingRegionCache) != -1
          ) {
            resolve(pingRegionCache);
            return;
          }
          let pingList = yield this.fetchPingList();
          let err = 0;
          let foundDefault = false;
          for (let region in pingList) {
            let host = pingList[region];
            // let scheme = host.endsWith(":6767") ? "http:" : "https:";
            let scheme = host.includes(":") ? "http:" : "https:";
            fetch(scheme + "//" + host + "/ping")
              .then(() => {
                if (!foundDefault) {
                  ClientManager.setDefaultRegion(region);
                }
                foundDefault = true;
                resolve(region);
              })
              .catch(() => {
                err++;
                if (err >= Object.keys(pingList).length) {
                  reject("All pings failed.");
                }
              });
          }
        }),
      );
    });
  }
  switchGame(id) {
    window.location.href = this.generateHref(id);
  }
  static setDefaultRegion(k) {
    localStorage.setItem(ClientManager.PING_REGION_CACHE_KEY, k);
  }
  parseQuery() {
    this.log("Parsing query...");
    var k = urlParse(location.href, true).query.game;
    if (typeof k == "string") {
      return k;
    } else {
      return null;
    }
  }
  fetchPingList() {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Fetching list of servrs to ping...");
      return yield this.matchmakerRequest("/ping-list", {
        hostname: this.hostname,
      });
    });
  }
  fetchGameList() {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Fetching game list...");
      return yield this.matchmakerRequest("/game-list", {
        hostname: this.hostname,
      });
    });
  }
  fetchGameInfo(k) {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Fetching game info for " + k + "...");
      return yield this.matchmakerRequest("/game-info", {
        game: k,
      });
    });
  }
  matchmakerSeek(
    regionId,
    gameId = null,
    m,
    autoChangeGame = true,
    validationToken,
    captchaToken = null,
  ) {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Seeking matchmaker with region " + regionId + "...");
      let params = {
        hostname: this.hostname,
        region: regionId,
        autoChangeGame: autoChangeGame,
        validationToken: validationToken,
      };
      if (gameId) {
        params.game = gameId;
      }
      if (m) {
        params.dataQuery = JSON.stringify(m);
      }
      if (captchaToken) {
        params.captchaToken = captchaToken;
      }
      return yield this.matchmakerRequest("/seek-game", params);
    });
  }
  queue(k) {
    return __awaiter(this, undefined, undefined, function* () {
      if (this.queueManager) {
        this.unqueue();
      }
      let l = new QueueManager(
        this,
        k.clientId,
        k.clientKey,
        k.statusCallback,
        k.hostCallback,
        k.joinCallback,
        k.cancelJoinCallback,
        k.kickCallback,
      );
      this.queueManager = l;
      return yield l._start();
    });
  }
  unqueue() {
    return __awaiter(this, undefined, undefined, function* () {
      this.queueManager = undefined;
    });
  }
  queueUpdateReady(isReady) {
    return __awaiter(this, undefined, undefined, function* () {
      if (this.queueManager != null) {
        let l = yield this.matchmakerRequest("/queue/update-ready", {
          clientKey: this.queueManager.queueClientKey,
          isReady: isReady,
        });
        if (this.queueManager) {
          this.queueManager._handleNewPollResponse(l);
        }
      }
    });
  }
  queueUpdateQueues(queues) {
    return __awaiter(this, undefined, undefined, function* () {
      if (this.queueManager != null) {
        let l = yield this.matchmakerRequest("/queue/update-queues", {
          clientKey: this.queueManager.queueClientKey,
          queues: JSON.stringify(queues),
        });
        if (this.queueManager) {
          this.queueManager._handleNewPollResponse(l);
        }
      }
    });
  }
  queueUpdateClass(classIndex) {
    return __awaiter(this, undefined, undefined, function* () {
      if (this.queueManager != null) {
        let l = yield this.matchmakerRequest("/queue/update-class", {
          clientKey: this.queueManager.queueClientKey,
          classIndex: classIndex,
        });
        if (this.queueManager) {
          this.queueManager._handleNewPollResponse(l);
        }
      }
    });
  }
  queueKickPartyMember(clientId) {
    return __awaiter(this, undefined, undefined, function* () {
      if (this.queueManager != null) {
        let l = yield this.matchmakerRequest("/queue/kick-party-member", {
          clientKey: this.queueManager.queueClientKey,
          kickClientId: clientId,
        });
        if (this.queueManager) {
          this.queueManager._handleNewPollResponse(l);
        }
      }
    });
  }
  queuePromotePartyMember(clientId) {
    return __awaiter(this, undefined, undefined, function* () {
      if (this.queueManager != null) {
        let l = yield this.matchmakerRequest("/queue/promote-party-member", {
          clientKey: this.queueManager.queueClientKey,
          promoteClientId: clientId,
        });
        if (this.queueManager) {
          this.queueManager._handleNewPollResponse(l);
        }
      }
    });
  }
  generateHref(k) {
    return "/?game=" + k;
  }
  matchmakerRequest(endpoint, params = {}) {
    return __awaiter(this, undefined, undefined, function* () {
      this.log(
        "Executing matchmaker request " +
          endpoint +
          " with params " +
          JSON.stringify(params) +
          "...",
      );
      for (let p in params) {
        if (params[p] == null) {
          delete params[p];
        }
      }
      let m = new URLSearchParams(params).toString();
      let o = yield fetch(
        "" + this.matchmakerAddress + endpoint + (m ? "?" + m : ""),
        {
          headers: new Headers({
            "accept-language": "en-US,en;q=0.6;",
          }),
        },
      );
      if (o.ok) {
        return yield o.json();
      }
      {
        let q = null;
        try {
          q = yield o.json();
        } catch (v) {}
        let u = {
          message: o.statusText,
          response: {
            data: q,
          },
        };
        console.error("Matchmaker request error", u);
        throw u;
      }
    });
  }
  log(...k) {
    if (this.enableLogging) {
      return (console.debug || console.info || console.log)(...k);
    } else {
      return undefined;
    }
  }
}
exports.default = ClientManager;
ClientManager.PING_REGION_CACHE_KEY = "sid-utils:ping-region";
